<template>
  <div class="setting-box">
    <a class="setting-button" @click="showModal">设置</a>
    <a-modal
      centered
      title="设置"
      :visible="visible"
      @cancel="handleCancel"
      @ok="submitEvent"
      okText="保存"
      :width=600
    >
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="formLayout.labelCol"
        :wrapper-col="formLayout.wrapperCol">
        <a-form-model-item label="客服类型" prop="customerType">
          <a-radio-group v-model="ruleForm.customerType">
            <a-radio :value="1">在线客服</a-radio>
            <a-radio :value="2">微信客服</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="ruleForm.customerType==2">
          <a-form-model-item label="企业ID" prop="corpId">
            <a-input v-model.trim="ruleForm.corpId" placeholder="请输入企业微信ID"></a-input>
          </a-form-model-item>
          <a-form-model-item label="微信客服Secret" prop="corpSecret">
            <a-input v-model.trim="ruleForm.corpSecret" placeholder="请输入微信客服Secret"></a-input>
          </a-form-model-item>
          <a-form-model-item label="Token" prop="token">
            <a-input v-model.trim="ruleForm.token" placeholder="请输入Token"></a-input>
          </a-form-model-item>
          <a-form-model-item label="EncodingAESKey" prop="encodingAesKey">
            <a-input v-model.trim="ruleForm.encodingAesKey " placeholder="请输入EncodingAESKey"></a-input>
          </a-form-model-item>
          <a-form-model-item label="通讯录同步Secret" prop="addressSecret">
            <a-input v-model.trim="ruleForm.addressSecret" placeholder="请输入通讯录同步Secret"></a-input>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'SettingComponent',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 17
        }
      },
      ruleForm: {
        customerType: '',
        corpId: '',
        corpSecret: '',
        addressSecret: '',
        token: '',
        encodingAesKey: ''
      },
      rules: {
        customerType: [{ required: true, message: '请选择客服类型', trigger: 'blur' }],
        corpId: [{ required: true, message: '请输入企业微信ID', trigger: 'blur' }],
        corpSecret: [{ required: true, message: '请输入微信客服Secret', trigger: 'blur' }],
        token: [{ required: true, message: '请输入Token', trigger: 'blur' }],
        encodingAesKey: [{ required: true, message: '请输入EncodingAESKey', trigger: 'blur' }],
        addressSecret: [{ required: true, message: '请输入通讯录同步Secret', trigger: 'blur' }]
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      servicesettingId: ''
    }
  },
  activated() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.platformId = this.getPlatformConfig().platformId
    this.getSettingType(false)
  },
  methods: {
    getSettingType(isQuery) {
      let params = {
        servicesettingMerchantId: this.merchantId,
        servicesettingPlatformId: this.platformId
      }
      this.getHttpServices()
        .getServerApiService()
        .post('service/getServiceSettingService', params)
        .then(res => {
          this.ruleForm.customerType = res.customerType ? res.customerType : ''
          this.servicesettingId = res.servicesettingId
          if (res.customerType == 1) {
            this.$store.commit('SET_MENU_HEAD_CONFIG', [
              { name: 'QuestionTemplate', title: '问答模板' },
              { name: 'OnlineServiceList', title: '咨询记录' }
            ])
          } else if (res.customerType == 2) {
            this.$store.commit('SET_MENU_HEAD_CONFIG', [
              { name: 'QuestionTemplate', title: '问答模板' },
              { name: 'WechatManagement', title: '微信客服管理' }
            ])
            if (isQuery) {
              this.getWxCustomerConfig()
            }
          }
          if (!res.customerType) {
            this.$emit('change', true)
          }
        })
        .catch(err => {
          this.getLogUtils().errorWithTag('========getServiceSettingService=========', err)
        })
    },
    getWxCustomerConfig() {
      let params = {
        servicesettingMerchantId: this.merchantId,
        servicesettingPlatformId: this.platformId
      }
      this.getHttpServices()
        .getServerApiService()
        .post('service/getWxCustomerConfig', params)
        .then(res => {
          this.ruleForm.corpId = res.corpId
          this.ruleForm.corpSecret = res.corpSecret
          this.ruleForm.addressSecret = res.addressSecret
          this.ruleForm.token = res.token
          this.ruleForm.encodingAesKey = res.encodingAesKey
        })
        .catch(err => {
          this.getLogUtils().errorWithTag('========getServiceSettingService=========', err)
        })
    },
    showModal() {
      this.$emit('change', true)
      this.getSettingType(true)
    },
    handleCancel() {
      this.$emit('change', false)
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = {
        servicesettingId: this.servicesettingId,
        servicesettingMerchantId: this.merchantId,
        servicesettingPlatformId: this.platformId,
        customerType: this.ruleForm.customerType,
        addressSecret: this.ruleForm.addressSecret,
        corpId: this.ruleForm.corpId,
        corpSecret: this.ruleForm.corpSecret,
        token: this.ruleForm.token,
        encodingAesKey: this.ruleForm.encodingAesKey
      }
      this.getHttpServices()
        .getServerApiService()
        .post('service/updateCustomerType', params)
        .then(res => {
          this.getSettingType(false)
          this.$emit('change', false)
          this.$emit('submit', this.ruleForm.customerType)
        })
        .catch(err => {
          this.showNetWorkErrorMessage(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.setting-box {
  .setting-button {
    position: fixed;
    top: 20px;
    right: 180px;
  }
}
</style>